import React, { useState, useEffect } from "react";

import WithAuthLayout from "../withAuthLayout";

import { useLocalStorage } from "../../hooks/useLocalStorage";

import "react-phone-input-2/lib/bootstrap.css";
import Step1 from "./(components)/Step1";
import Step2 from "./(components)/Step2";
import Step3 from "./(components)/Step3";

const SignUp: React.FC = () => {
  const [step, setStep] = useState(1);
  const [relayId, setRelayId] = useState<string>("");
  const [token, setToken] = useState<string>("");
  const [email, setEmail] = useState<string>("");

  const [createdUserData, setCreatedUserData]: any = useLocalStorage(
    "created_user_details",
    {
      relayId: "",
      userId: "",
      email: "",
      token: "",
    }
  );

  useEffect(() => {
    setRelayId(createdUserData?.relayId || "");
    setToken(createdUserData?.token || "");
    setEmail(createdUserData?.email || "");
  }, [
    createdUserData?.relayId,
    createdUserData?.email,
    createdUserData?.token,
  ]);

  return (
    <main className="d-flex align-items-center gap-5 justify-content-between">
      {step === 1 && (
        <Step1 setCreatedUserData={setCreatedUserData} setStep={setStep} />
      )}

      {step === 2 && (
        <Step2
          createdUserData={createdUserData}
          setStep={setStep}
          step={step}
          token={token}
          relayId={relayId}
          email={email}
          setCreatedUserData={setCreatedUserData}
        />
      )}

      {step === 3 && <Step3 createdUserData={createdUserData} email={email} />}
    </main>
  );
};

export default WithAuthLayout(SignUp);
